var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-flag-container"},[_c('div',{staticClass:"icon-flag"},[(_vm.country)?_c('CountryFlag',{attrs:{"country":_vm.country,"size":"big","rounded":true}}):_c('el-image',{staticClass:"preview",staticStyle:{"width":"100%","height":"100%","border-radius":"5px"},attrs:{"src":_vm.studioLogo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }